import { IOrderBump } from "../../core/types/OrderBump"
import { TCheckoutLayout } from "../../core/types/Checkout"
import CheckoutOrderBumpsDefault from "./Layouts/LayoutDefault/CheckoutOrderBumpsDefault"
import CheckoutOrderBumps2 from "./Layouts/Layout2/CheckoutOrderBumps2"
import React from "react"
import CheckoutOrderBumps3 from "./Layouts/Layout3/CheckoutOrderBumps3"
import CheckoutOrderBumps4 from "./Layouts/Layout4/CheckoutOrderBumps4"
import CheckoutOrderBumps5 from "./Layouts/Layout5/CheckoutOrderBumps5"
import CheckoutOrderBumps6 from "./Layouts/Layout6/CheckoutOrderBumps6"
import CheckoutOrderBumps7 from "./Layouts/Layout7/CheckoutOrderBumps7"
import CheckoutOrderBumps8 from "./Layouts/Layout8/CheckoutOrderBumps8"

interface ICheckoutOrderBumps {
  layout?: TCheckoutLayout
  paymentInstallment: number
  paymentMethodType: number
  orderBumps?: IOrderBump[]
  orderBumpChange: (orderBump: IOrderBump) => Promise<void>
}

const CheckoutOrderBumps = ({
  layout,
  paymentInstallment,
  paymentMethodType,
  orderBumps,
  orderBumpChange,
}: ICheckoutOrderBumps) => {
  if ((orderBumps?.length ?? 0) <= 0 || !layout) {
    return <></>
  }

  const checkoutOrderBumpsData = {
    [TCheckoutLayout.Default]: (
      <CheckoutOrderBumpsDefault
        orderBumps={orderBumps}
        orderBumpChange={orderBumpChange}
      />
    ),
    [TCheckoutLayout.Layout2]: (
      <CheckoutOrderBumps2
        orderBumps={orderBumps}
        orderBumpChange={orderBumpChange}
      />
    ),
    [TCheckoutLayout.Layout3]: (
      <CheckoutOrderBumps3
        key={`orderBumps${orderBumps?.length}`}
        orderBumps={orderBumps}
        orderBumpChange={orderBumpChange}
      />
    ),
    [TCheckoutLayout.Layout4]: (
      <CheckoutOrderBumps4
        key={`orderBumps${orderBumps?.length}`}
        paymentInstallment={paymentInstallment}
        paymentMethodType={paymentMethodType}
        orderBumps={orderBumps}
        orderBumpChange={orderBumpChange}
      />
    ),
    [TCheckoutLayout.Layout5]: (
      <CheckoutOrderBumps5
        key={`orderBumps${orderBumps?.length}`}
        paymentInstallment={paymentInstallment}
        paymentMethodType={paymentMethodType}
        orderBumps={orderBumps}
        orderBumpChange={orderBumpChange}
      />
    ),
    [TCheckoutLayout.Layout6]: (
      <CheckoutOrderBumps6
        key={`orderBumps${orderBumps?.length}`}
        paymentInstallment={paymentInstallment}
        paymentMethodType={paymentMethodType}
        orderBumps={orderBumps}
        orderBumpChange={orderBumpChange}
      />
    ),
    [TCheckoutLayout.Layout7]: (
      <CheckoutOrderBumps7
        key={`orderBumps${orderBumps?.length}`}
        paymentInstallment={paymentInstallment}
        paymentMethodType={paymentMethodType}
        orderBumps={orderBumps}
        orderBumpChange={orderBumpChange}
      />
    ),
    [TCheckoutLayout.Layout8]: (
      <CheckoutOrderBumps8
        key={`orderBumps${orderBumps?.length}`}
        paymentInstallment={paymentInstallment}
        paymentMethodType={paymentMethodType}
        orderBumps={orderBumps}
        orderBumpChange={orderBumpChange}
      />
    ),
  }

  return checkoutOrderBumpsData[layout] || <></>
}

export default CheckoutOrderBumps
